/* @flow */

import { StorageKeys } from './keys';
import LocalStorageManager from './localStorageManager';

const deleteOptimisticData = (): void => {
  LocalStorageManager.delete(StorageKeys.OptimisticDmsSettings);
};

export { deleteOptimisticData };
